// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../../graphql/api/index';

import { LinkFragmentDoc, LinkItemFragmentDoc, PageLinkFragmentDoc, PostLinkFragmentDoc, CustomLinkFragmentDoc, LinkQuestionnaireFragmentDoc, LinkItemOpenEnquiryFormFragmentDoc, LinkItemErRecommendationsFragmentDoc } from '../../../../cms/index.generated';
export const PreHeaderFragmentDoc = `
    fragment preHeader on PreHeader {
  __typename
  link {
    ...link
  }
}
    `;